module.exports = __webpack_public_path__ + "static/media/76.058beacd.png";